<div class="container mx-auto" *ngIf="!isRescheduledCompleted">
    <div class="title">
        <h2>
            Details
        </h2>
    </div>
    <div class="text-left border-b-2 border-slate-200 dark:border-darkmode-400">
        <div class="flex flex-col px-5 pt-5 pb-0 lg:flex-row sm:px-20 sm:pb-20">
            <div>
                <div class="mt-1">Date: {{ bookingData.created_at | date:'MMM dd, yyyy' }}</div>
                <div class="mt-2 text-lg font-bold text-red-700"> Name: <span
                        class="text-black">{{bookingData.name}}</span> </div>
                <div class="mt-1">Phone: +91 {{bookingData.phone}}</div>
                <div class="mt-1"></div>
            </div>
            <div class="mt-10 lg:text-right lg:mt-0 lg:ml-auto justify-items-start">
                <div class="text-base  font-bold text-left">Booking Number :&nbsp;<span
                        class="font-medium text-red-700">{{bookingData.booking_no}}</span></div>
                <div class="mt-2 text-sm font-semibold text-primary text-left">Country :&nbsp;
                    <span>{{bookingData.slot.entity}}</span>
                </div>

                <div class="mt-2 text-sm font-semibold text-primary text-left">Slot :&nbsp;{{bookingData.slot.start_time
                    |
                    date:'dd/MM/yyyy'}} {{bookingData.slot.start_time | date: 'h:mm a'}}-{{bookingData.slot.end_time |
                    date: 'h:mm a'}}</div>
                <div class="mt-1"></div>
            </div>
        </div>
    </div>
    <div class="title">
        <h2>
            Please Select a Date
        </h2>
    </div>

    <div class="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4">
        <div class="">
            <mat-card class="slot-calendar">
                <mat-calendar (selectedChange)="onSelected($event)" [startAt]="startDate" [dateClass]="dateClass"
                    [(selected)]="selected" (monthSelected)="monthSelected($event)" #myCalendar></mat-calendar>
            </mat-card>
        </div>
        <div *ngIf="isSlotsLoaded && slots?.length > 0 && selected !== ''" class="mt-5 lg:mt-0">
            <div class="slots-list sm:ml-0 md:ml-0 lg:ml-3">
                <mat-list>
                    <div class="text-center slot-title" mat-subheader>Available slots on {{selected | date:'MMMM
                        d,YYYY'}}</div>
                    <mat-divider></mat-divider>
                    <div *ngFor="let slot of slots">
                        <div class="slots flex justify-between items-center">
                            <mat-list-item [disabled]="slot.blocked || slot.is_break || slot.slotsLimited">
                                <mat-icon matListItemIcon>access_time_filled</mat-icon>
                                <div *ngIf="!slot.blocked && !slot.is_break" class="font-bold slot-time"
                                    matListItemTitle>{{slot.start_time | date: 'h:mm a'}} -
                                    {{slot.end_time | date: 'h:mm a'}}
                                </div>
                                <div *ngIf="!slot.blocked && slot.is_break" class="font-bold slot-time"
                                    matListItemTitle>{{slot.start_time | date: 'h:mm a'}} -
                                    {{slot.end_time | date: 'h:mm a'}}
                                </div>
                                <div *ngIf="slot.blocked && !slot.is_break" class="font-bold slot-time"
                                    matListItemTitle>{{slot.start_time | date: 'h:mm a'}} -
                                    {{slot.end_time | date: 'h:mm a'}}
                                </div>
                                <div *ngIf="!slot.blocked && !slot.is_break" matListItemLine class="slot-count">
                                    {{slot.available_slot_count}} slots
                                    available</div>
                                <div *ngIf="slot.blocked && !slot.is_break" matListItemLine class="slot-count">
                                    <span>{{slots.title !== "" ? 'Slots Blocked' : slot.title}}</span>
                                </div>
                                <div *ngIf="!slot.blocked && !slot.is_break && slot.slotsLimited" matListItemLine
                                    class="slot-count">
                                    <span>Sorry! We have only {{slot.available_slot_count}} slots available. Please
                                        select another date</span>
                                </div>
                                <div *ngIf="!slot.blocked && slot.is_break" matListItemLine class="slot-count">
                                    <span>{{slots.title !== "" ? 'Break' : slot.title}}</span>
                                </div>
                            </mat-list-item>
                            <button spinnerButton [loading]="isLoading" mat-raised-button color="primary"
                                (click)="slotRegistration(slot)"
                                *ngIf="!slot.blocked && !slot.is_break && !slot.slotsLimited">
                                <span class="text-white" *ngIf="!isLoading">Reschedule</span>
                            </button>
                        </div>
                        <mat-divider></mat-divider>
                    </div>
                </mat-list>
            </div>
        </div>
        <div *ngIf="isSlotsLoaded && slots?.length < 1 && selected !== ''" class="flex justify-center items-center">
            <p>Sorry.! No slots available for this date</p>
        </div>
        <div *ngIf="selected == ''" class="flex justify-center items-center">
            <p>Please select a date for booking.</p>
        </div>
        <div *ngIf="!isSlotsLoaded" class="mt-5 lg:mt-0">
            <div class="slots-list sm:ml-0 md:ml-0 lg:ml-3">
                <mat-list>
                    <div class="text-center slot-title my-3" mat-subheader>
                        <ngx-skeleton-loader count="1" appearance="line"
                            [theme]="{height: '30px', margin:'0'}"></ngx-skeleton-loader>
                    </div>
                    <div *ngFor="let slot of loaderSlots">
                        <div class="slots flex justify-between items-center">
                            <mat-list-item>
                                <div class="font-bold slot-time" matListItemTitle>
                                    <ngx-skeleton-loader [theme]="{height: '21px', margin:'5% 0'}" count="1"
                                        appearance="line"></ngx-skeleton-loader>
                                </div>
                            </mat-list-item>
                        </div>
                    </div>
                </mat-list>
            </div>
        </div>
    </div>
</div>
<div class="container mx-auto mt-3 mb-10" *ngIf="isRescheduledCompleted">
    <div class="flex items-center justify-center h-screen">
        <div>
            <div class="flex flex-col items-center space-y-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="text-green-600 w-28 h-28" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="1">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <h1 class="text-4xl font-bold">{{rescheduleResponse.data.message}}</h1>
                <p class="text-xl">Your new booking reference number is #{{rescheduleResponse.data.details.booking_number}}.</p>

                <button mat-flat-button color="primary" class="custom-home-btn" (click)="homeButton()">
                    <div class="flex items-center">
                        <span class="material-symbols-outlined">home</span>
                        Home
                    </div>
                </button>
            </div>
        </div>
    </div>
</div>